import { OpenStreetMap } from "./OpenStreetMap";
import { BingMap } from "./BingMap";
export { OpenStreetMap, BingMap };
export default {
  OpenStreetMap: OpenStreetMap,
  BingMap: BingMap
};